import {
  Accordion,
  AccordionDetails,
  AccordionProps,
  AccordionSummary,
  Typography
} from '@mui/material'
import { useTranslation } from 'react-i18next'
import { Device } from '../types'
import { ExpandMore } from '@mui/icons-material'
import DeviceDetailsList from './DeviceDetailsList'

export interface DeviceDetailsAccordionProps extends Omit<AccordionProps, 'children'> {
  device: Device
}

export default function DeviceDetailsAccordion({ device, ...props }: DeviceDetailsAccordionProps) {
  /**
   * The translate function.
   */
  const [t] = useTranslation()

  return (
    <Accordion
      {...props}
      sx={{
        boxShadow: 0,
        '::before': { display: 'none' },
        '& .MuiAccordionSummary-root': {
          pl: 2,
          pr: 4
        }
      }}
    >
      <AccordionSummary expandIcon={<ExpandMore />}>
        <Typography fontWeight={500}>{t('deviceDetails')}</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <DeviceDetailsList device={device} />
      </AccordionDetails>
    </Accordion>
  )
}
